import { ref, computed } from '@vue/composition-api'
import { apiToastSuccess, apiToastWarning } from '@/@core/utils/toast'
import analytics from '@/@core/utils/analytics'
import constants from '@/constants'
import store from '@/store'
import { GET_COLLECTION_LIST, REORDER_COLLECTION } from '@/store/modules/collection.module'
import { constants as c } from '@kingpin-global/kingpin-utils-frontend'

const { COLLECTION_STATUS } = c

export function useCollectionList() {
  const isLoaded = ref(false)
  const brandCollection = ref([])
  const previousCollection = ref([])

  const profile = computed(() => store.getters.profile)
  const currentAssociationEntityName = computed(
    () => store.getters.getCurrentAssociation?.entity?.entityName,
  )

  async function fetchCollections() {
    await store
      .dispatch(GET_COLLECTION_LIST)
      .then(res => {
        const collections = res.data.data.collections
        brandCollection.value = collections.filter(
          col => col.status !== COLLECTION_STATUS.EXPIRED.VALUE,
        )
        previousCollection.value = collections.filter(
          col => col.status === COLLECTION_STATUS.EXPIRED.VALUE,
        )
        isLoaded.value = true
      })
      .catch(() => { })
    analytics.track(constants.TRACKS.PAGES.BRAND_COLLECTIONS)
  }

  function onDragged(data) {
    const draggedCollection = data.moved
    const draggedCollectionId = draggedCollection.element._id
    const newIndex = draggedCollection.newIndex
    store
      .dispatch(REORDER_COLLECTION, {
        collectionId: draggedCollectionId,
        orderIndex: newIndex,
      })
      .then(() => {
        apiToastSuccess('Dragged successfully')
      })
      .catch(() => {
        apiToastWarning('Dragging failed')
      })
  }

  function addCollection() {
    analytics.track(constants.TRACKS.ACTIONS.BRAND_STARTS_ADDING_COLLECTION)
  }

  return {
    isLoaded,
    brandCollection,
    previousCollection,
    profile,
    currentAssociationEntityName,
    fetchCollections,
    onDragged,
    addCollection,
  }
}
